import React from 'react';
import './firstSlider.css'
import { Link } from 'react-router-dom';

const FirstSlider = (props) => {

    
const styles = {

  };

  return (
    <div className='slider-container' style={{backgroundImage:`url(${props.img})`}}>
      <div className='slider-inner-gradient'>
      <p className='slider-container-header'>
      World-class Digital Infrastructure utilizing cutting-edge Technology
      </p>
      <p className='slider-container-details'>
      Modern problems require Modern Solutions, We bring State of the art Technology Solutions and Products to meet Business requirements
      </p>
      <div className='slider-container-btn'>
      <Link to={'/contactus'} style={{textDecoration:"none", textTransform:"none"}} > <button className='slider-btn'>Contact Us</button></Link>
        {/* <button className='slider-btn'>IT Solution</button> */}
      </div>
      </div>
    </div>
  );
};


export default FirstSlider;
